/**
 * Session storage keys, used to store session-bound flags.
 */
export const sessionStorageKeys = {
  CHROME_APP: "arduino::chrome-app",
  TEMPLATES_FILTER_BOARDS: "arduino::templates-filter-boards"
} as const

/**
 * Local storage keys, used to store persistent flags or values.
 */
export const localStorageKeys = {
  THING_SKETCH_NOTIFICATIONS: "arduino::thing-sketch-notifications",
  SMART_FOLDER_DELETE_REQUEST_CONFIRMATION: "arduino::smart-folder-delete-confirmation"
} as const
